<template>
  <div class="box">
    <el-table
      border
      :data="list"
      style="width: 100%"
      :height="`${viewportHeight - 100}px`"
    >
      <el-table-column prop="created_at" label="创建时间"> </el-table-column>
      <el-table-column label="设备名称" width="380">
        <template slot-scope="scope">
          {{ scope.row.device_detail.name }}
        </template>
      </el-table-column>
      <el-table-column label="工单位置" width="380">
        <template slot-scope="scope">
          {{ scope.row.device_detail.address }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="工单状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == '未读'" type="danger">未读</el-tag>
          <el-tag v-if="scope.row.status == '已读未解决'" type="warning"
            >已读未解决</el-tag
          >
          <el-tag v-if="scope.row.status == '已解决'" type="success"
            >已解决</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="工单详情">
        <template slot-scope="scope">
          <el-button type="primary" @click="getBody(scope.row)">
            工单详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="工单详情"
      :visible.sync="dialogVisible"
      width="30%"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <span>{{ obj.description }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="solve(obj, '返回')">返 回</el-button>
        <el-button
          v-if="obj.status == '已读未解决' || obj.status == '未读'"
          type="primary"
          @click="solve(obj, '已解决')"
          >已解决</el-button
        >
      </span>
    </el-dialog>
    <ViewportSize @viewport-size-update="onViewportSizeUpdate"></ViewportSize>
  </div>
</template>

<script>
import { alltickets, updateticket } from "@/uitl/api";
import { parseDateTime } from "@/utils/time";

import indexScreen from "./indexScreen.vue";
import imgScreen from "./imgScreen.vue";
import navScreen from "./navScreen.vue";
export default {
  name: "",
  components: {
    indexScreen,
    imgScreen,
    navScreen,
  },
  props: {},
  data() {
    return {
      viewportHeight: 0,
      index: 5,
      dialogVisible: false,
      list: [],
      obj: {},
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.getAllticketst();
  },
  methods: {
    onViewportSizeUpdate(width, height) {
      this.viewportHeight = height;
    },
    getAllticketst() {
      alltickets().then((res) => {
        console.log(this.list);
        res.data.data.forEach((item) => {
          item.created_at = parseDateTime(item.created_at);
        });
        this.list = res.data.data;
      });
    },
    getBody(data) {
      console.log(data);
      this.obj = data;
      this.dialogVisible = true;
    },
    solve(obj, text) {
      if (text == "已解决") {
        let from = {
          title: obj.title,
          description: obj.description,
          status: "已解决",
        };
        updateticket(obj._id, from).then((res) => {
          console.log(res);
          this.getAllticketst();
          this.$message({
            type: "success",
            message: "解决成功!",
          });
          this.dialogVisible = false;
        });
      }
      if (text == "返回") {
        if (obj.status == "已解决") {
          this.dialogVisible = false;
        } else {
          let from = {
            title: obj.title,
            description: obj.description,
            status: "已读未解决",
          };
          updateticket(obj._id, from).then((res) => {
            console.log(res);
            this.getAllticketst();
            this.dialogVisible = false;
          });
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
</style>
